import { BadgeCheck, Eye, Images, MapPinned, MoveHorizontal, Route } from "lucide-react";

export function Thera360RoutesPage() {
  return (
    <section className="thera-product-page thera-360-page" aria-labelledby="thera-360-routes-title">
      <header className="thera-product-hero">
        <span className="thera-product-icon thera-360-badge">360°</span>
        <div>
          <p className="eyebrow">THERA 360 Routes · EXPERIENCIAS INMERSIVAS</p>
          <h1 id="thera-360-routes-title">Rutas y lugares vistos desde el terreno.</h1>
          <p>Acceso público independiente al sistema 360 que THERA ya comenzó a desarrollar.</p>
        </div>
        <span className="thera-status beta">Beta</span>
      </header>

      <div className="thera-360-stage">
        <MoveHorizontal />
        <strong>Visor 360</strong>
        <small>Las experiencias publicadas aparecerán aquí después de validación.</small>
      </div>

      <div className="thera-product-grid">
        <article><Route /><strong>THERA 360 Routes</strong><small>Paradas asociadas progresivamente a un recorrido.</small></article>
        <article><MapPinned /><strong>POI con 360</strong><small>Un punto podrá indicar “360 disponible”.</small></article>
        <article><Images /><strong>Panoramas</strong><small>Reutiliza el flujo de panorámicas que ya existe en THERA.</small></article>
        <article><Eye /><strong>Publicación controlada</strong><small>Solo experiencias revisadas serán visibles para usuarios.</small></article>
      </div>

      <div className="thera-control-note"><BadgeCheck /><div><strong>Base existente protegida</strong><p>Este acceso no reemplaza el constructor 360 actual; funcionará como puerta pública hacia experiencias validadas.</p></div></div>
    </section>
  );
}
